<!-- ADD CASHOUT -->
<p-dialog
  class="filters-modal"
  header="Agregar cashout"
  [modal]="true"
  [(visible)]="showNewTransactionType"
  [style]="{ width: '600px' }"
  *ngIf="showNewTransactionType"
  (visibleChange)="closeAddModal()"
>
  <div class="pick-title" *ngIf="showCurrency">
    Selecciona la moneda del cashout
  </div>
  <div class="form-item" *ngIf="showCurrency">
    <p-dropdown
      placeholder="Elige la moneda"
      [options]="allowedCashoutCurrencies"
      optionLabel="id"
      [(ngModel)]="currencyPicker"
      (onChange)="selectCurrency($event)"
    />
  </div>

  <div class="buttons-container">
    <p-button
      label="Cancelar"
      severity="danger"
      (click)="exitNewTransaction()"
    />
    <p-button
      label="Continuar"
      [disabled]="checkContinueDisabled()"
      severity="secondary"
      (click)="continue()"
    />
  </div>
</p-dialog>

<p-dialog
  class="filters-modal"
  header="Confirmar cashout"
  [modal]="true"
  [(visible)]="showCashoutConfirmation"
  [style]="{ width: '560px' }"
  *ngIf="showCashoutConfirmation"
  (visibleChange)="backToCashoutForm()"
>
  <app-cashout-confirmation
    [details]="cashoutConfirmationDetails"
    [addingTransaction]="addingTransaction"
    (back)="backToCashoutForm()"
    (confirm)="confirmCashout()"
  />
</p-dialog>

<app-ves-form
  *ngIf="showNewTransaction && currency == 'VES'"
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>
<app-mxn-form
  *ngIf="showNewTransaction && currency == 'MXN'"
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>
<app-eur-form
  *ngIf="showNewTransaction && currency == 'EUR'"
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>
<app-cop-form
  *ngIf="showNewTransaction && currency == 'COP'"
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>
<app-aed-form
  *ngIf="showNewTransaction && currency == 'AED'"
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>
<app-usd-form
  *ngIf="showNewTransaction && currency == 'USD'"
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>
<app-btc-form
  *ngIf="showNewTransaction && currency == 'BTC'"
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>
<app-eth-form
  *ngIf="showNewTransaction && currency == 'ETH'"
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>
<app-usdt-form
  *ngIf="showNewTransaction && currency == 'USDT'"
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>
<app-latam-notbank-form
  *ngIf="
    showNewTransaction &&
    (currency == 'BRL' ||
      currency == 'CLP' ||
      currency == 'PEN' ||
      currency == 'ARS')
  "
  [ctx]="cashoutContext"
  (draftReady)="openCashoutConfirmationFromDraft($event)"
/>

<app-notbank-provision-dialog
  [(visible)]="showNotbankProvision"
  [clientId]="notbankProvisionClientId"
  [currency]="currency"
  [missingFields]="notbankProvisionMissing"
  [partialRegister]="notbankProvisionPartial"
  [bankAccount]="notbankProvisionBank"
  [errorMessage]="notbankProvisionError"
  (provisioned)="onNotbankProvisioned($event)"
  (cancelled)="onNotbankProvisionCancelled()"
/>
